import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ArticleCard } from '@app/components/ArticleCard';
import { selectHasFiber } from '@app/redux/auth/authUserSlice';
import { openInNewTab } from '@app/redux/utils';

import { ArticleFiberImage } from './article-fiber-image';
import { ArticleImage } from './article-image';

const NetworkArticleCard = () => {
  const hasFiberInternet = useSelector(selectHasFiber);
  const translationKey = hasFiberInternet ? 'articleCardFiber' : 'articleCard';
  const { t } = useTranslation('Network', { keyPrefix: translationKey });

  const dispatch = useDispatch();

  const openLinkInNewTab = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(openInNewTab(t('linkUrl')));
  };

  return (
    <ArticleCard
      title={t('title')}
      caption={t('caption')}
      image={hasFiberInternet ? <ArticleFiberImage /> : <ArticleImage />}
      link={{ text: t('linkText'), url: t('linkUrl') }}
      onClick={(e) => openLinkInNewTab(e)}
    />
  );
};

export default NetworkArticleCard;
